import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import M from 'materialize-css/dist/js/materialize';
import * as lineInventoryAction from '../../../../actions/inventoryAction';
import InventoryService from '../../../../services/InventoryService';
import ListItemLot from './ListItemLotInventoryGeneral';
import { ENUMS, PERMISSIONS } from '../../../../utils/constants';
import { translate } from '../../../../utils/util';
import ConfirmModal from '../../../../components/UI/ConfirmModal';
import InfiniteScrollUl from '../../../../components/UI/InfiniteScrollUl';
import { checkPermission, getUser } from '../../../../services/auth';

const InventoryGeneralListLot = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [refresh, setRefresh] = useState(0);
    const [lot, setLot] = useState({});
    const [message, setMessage] = useState('');
    const filterRoute = props.location?.state;
    const isSupervisor = () => checkPermission(props.filter.typeInventory === 'G' ? PERMISSIONS.Inventory.General.Supervisor : PERMISSIONS.Inventory.Rotative.Supervisor);

    useEffect(() => {
        setCurrentPage(0);
        // eslint-disable-next-line
    }, [props.allLots]);

    useEffect(() => {
        if (!filterRoute?.byFilter && !filterRoute?.byFilterLot && !filterRoute?.divergentDrone) {
            props.resetFilter();
        } else if (filterRoute?.byFilter && !filterRoute?.byFilterLot) {
            props.filter.lotNumber = undefined;
        }

        Object.assign(props.filter, { allLots: props.allLots });
        props.getLots(props.user.vision, props.filter, {
            PageSize: 25,
            PageIndex: currentPage
        });
        // eslint-disable-next-line
    }, [currentPage, props.allLots, refresh]);

    const onSelectItemChange = (item) => {
        window.scrollTo(0, 0)
        props.setSelectedLot(item);
    };

    const onUnlonckUser = (event, selectedItem) => {
        setLot(selectedItem);
        setMessage(`Confirma o desbloqueio do lote ${selectedItem.lotNumber}`);
        const modal = M.Modal.init(document.getElementById('unlockUserLot'));
        modal.open();
    };

    const onConfirmModal = () => {
        props.unblockUser(lot.lotNumber, () => {
            if (currentPage > 0) {
                setCurrentPage(0)
                window.scrollTo(0, 0)
            } else {
                setRefresh(refresh + 1);
            }
        });
    };

    const onRefreshLots = (event, item) => {
        props.refreshLots(item, true);
    };

    const mapLost = () => {
        if (props.lots && props.lots.items) {
            if (filterRoute?.divergentDrone) {
                const array = [];
                props.lots.items.forEach((element) => {
                    const item = element.lotItems?.filter((l) => l.divergent === true && l.status !== ENUMS.eInventoryLotItemStatus.Finished.value
                        && l.readings.length === 0) || [];
                    if (item?.length > 0) {
                        array.push(element);
                    }
                });
                return array;
            } else {
                return props.lots.items;
            }
        }

        return []
    };

    const filterStatus = () => {
        if (props.lots && props.lots.items) {
            const total = !isSupervisor ? props.inventory.lots.filter((l) => l.startedBy === getUser().userName && l.status === ENUMS.eInventoryLotStatus.Finished.value).length :
                props.inventory.lots.filter((l) => l.status === ENUMS.eInventoryLotStatus.Finished.value).length;
            const totalWaiting = !isSupervisor ? props.inventory.lots.filter((l) => l.startedBy === getUser().userName && l.status !== ENUMS.eInventoryLotStatus.Waiting.value && l.status !== ENUMS.eInventoryLotStatus.Loading.value).length :
                props.inventory.lots.filter((l) => l.status !== ENUMS.eInventoryLotStatus.Waiting.value && l.status !== ENUMS.eInventoryLotStatus.Loading.value).length

            return `${translate('general.status')} ${total} / ${totalWaiting}`;
        }
        return '';
    }

    return (
        <>
            <div className="subtitle">
                {filterStatus()}
            </div>
            <InfiniteScrollUl
                page={props.lots?.totalPages}
                current={{ currentPage, setCurrentPage }}
                hasMore={currentPage < props.lots?.totalPages ? true : false}
                data={
                    mapLost().filter((f) => f.status !== ENUMS.eInventoryLotStatus.Canceled.value
                        && f.status !== ENUMS.eInventoryLotStatus.Finished.value).map((item, index) => {
                            return (
                                <ListItemLot
                                    // eslint-disable-next-line react/no-array-index-key
                                    key={`gi-${index}`}
                                    route="../general/lotItems"
                                    data={item}
                                    typeInventory={props.filter.typeInventory}
                                    onClickUnlonckUser={onUnlonckUser}
                                    onSelectChange={() => onSelectItemChange(item)}
                                    onRefreshLot={(event) => onRefreshLots(event, item)}
                                />
                            );
                        })
                }
            />
            <ConfirmModal
                id="unlockUserLot"
                data={{ title: translate('validations.attention'), message }}
                onConfirm={onConfirmModal}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </>
    )
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        filter: state.inventoryReducer.filter,
        lots: state.inventoryReducer.lots,
        inventories: state.inventoryReducer.inventoryList,
        inventory: state.inventoryReducer.inventory
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSelectedLot: (lot) => {
            dispatch(lineInventoryAction.selectLotInventory(lot));
        },
        getLots: (vision, filter, pagination) => {
            dispatch(InventoryService.getLots(vision, filter, pagination));
        },
        unblockUser: (lotId, callback) => {
            dispatch(InventoryService.unblockUserLots(lotId, callback));
        },
        refreshLots: (filter, showLoading) => {
            dispatch(InventoryService.refreshLots(filter, showLoading));
        },
        resetFilter: () => {
            dispatch(lineInventoryAction.resetFilters());
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InventoryGeneralListLot));
